import React, { createContext, useContext, useState, useEffect } from 'react';
import { storeAPI } from '../services/storefront';

const StoreConfigContext = createContext(null);

/**
 * Fetches GET /api/public/store once on mount.
 * Provides storeConfig (tenant name, currency, payment gateway, Razorpay keyId, policies…)
 * to the entire app without re-fetching on every component.
 */
export const StoreConfigProvider = ({ children }) => {
  const [storeConfig, setStoreConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    storeAPI.getConfig()
      .then((data) => setStoreConfig(data))
      .catch((err) => {
        console.error('Failed to load store config:', err);
        setError(err);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <StoreConfigContext.Provider value={{ storeConfig, loading, error }}>
      {children}
    </StoreConfigContext.Provider>
  );
};

export const useStoreConfig = () => {
  const ctx = useContext(StoreConfigContext);
  if (!ctx) throw new Error('useStoreConfig must be used within StoreConfigProvider');
  return ctx;
};
